import { ESFieldMappingDefinition, ESFieldTypeMap } from 'modules/workflows/types';

/**
 *
 * @param mappings
 * @returns object keyed by fieldName in order to match data structure used in FieldsMatchEditor, Filters and Delay Tile
 */
export const parseMappings = (mappings: ESFieldMappingDefinition[] = []): ESFieldTypeMap =>
  mappings?.reduce((acc, event) => {
    const { fieldName, fieldType } = event;
    acc[fieldName] = {
      field: fieldName,
      fieldType,
    };
    return acc;
  }, {} as ESFieldTypeMap) || {};
